var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10.7246,
    r: 9,
    stroke: "black",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7386 6.27273L10.5724 12.3835H9.01275L8.8423 6.27273H10.7386ZM9.79258 15.1108C9.51133 15.1108 9.26986 15.0114 9.06815 14.8125C8.86645 14.6108 8.76702 14.3693 8.76986 14.0881C8.76702 13.8097 8.86645 13.571 9.06815 13.3722C9.26986 13.1733 9.51133 13.0739 9.79258 13.0739C10.0625 13.0739 10.2997 13.1733 10.5042 13.3722C10.7088 13.571 10.8125 13.8097 10.8153 14.0881C10.8125 14.2756 10.7628 14.4474 10.6662 14.6037C10.5724 14.7571 10.4488 14.8807 10.2954 14.9744C10.142 15.0653 9.9744 15.1108 9.79258 15.1108Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.dcd7aceeaf6a7405b0a84b84c2fc9386.svg";
export { ForwardRef as ReactComponent };